(function () {
  if (window.location.pathname.indexOf('/products/') !== 0) return;

  var params = new URLSearchParams(window.location.search);
  var changed = false;

  ['country', 'currency'].forEach(function (key) {
    if (params.has(key)) {
      params.delete(key);
      changed = true;
    }
  });

  if (!changed) return;

  var nextSearch = params.toString();
  var nextUrl = window.location.pathname + (nextSearch ? '?' + nextSearch : '') + window.location.hash;
  window.history.replaceState(window.history.state, '', nextUrl);
})();
